export default function FloatButton() {
  return {}
}
